import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { config } from '../../config/config';
import BackButton from '../../components/BackButton'; 
import './PrivacyPolicy.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.style.setProperty('--main-color', config.color);
  }, []);
  
React.useEffect(() => {
  document.documentElement.style.setProperty("--backbutton-color", 'White');  // set static color
}, []);

  return (
    <>
    <Header/>
    <div className="privacy-policy-container">
      <div className='privacy_policy_page'>      
        
        <div className="privacytopdiv">
        <BackButton onClick={() => navigate('/Dashboard')} title="Privacy Policy" />
      </div>

      <div id="policy-content">
        <div>{config.privacyTitle}</div>
        <p>Effective Date: {config.privacyEffectiveDate}</p>

        {config.privacyPoints.map((section, index) => (
          <div key={index}>
            <div>{section.heading}</div>

            {section.subsections ? (
              section.subsections.map((sub, subIndex) => (
                <div key={subIndex}>
                  <div>{sub.heading}</div>
                  {sub.content.map((text, textIndex) => (
                    <p key={textIndex}>{text}</p>
                  ))}
                </div>
              ))
            ) : (
              section.content.map((text, textIndex) => (
                <p key={textIndex}>{text}</p>
              ))
            )}
          </div>
        ))}
      </div>
      </div>

    </div>
    <Footer/>
    </>
  );
};

export default PrivacyPolicy;
